import { TabStyles } from '@tableau/widgets';

export const buttonsContainer: React.CSSProperties = {
	paddingBottom: TabStyles.Spacing.LargeSpace,
};

export const toggle: React.CSSProperties = {
	width: 200,
	marginBottom: TabStyles.Spacing.DefaultSpace,
};

export const title: React.CSSProperties = {
	fontWeight: 'bold',
	height: '16px',
};

export const titleSpan: React.CSSProperties = {
	display: 'inline-flex',
	alignItems: 'center',
};

export const contentName: React.CSSProperties = {
	fontWeight: 'bold',
	fontSize: TabStyles.Typography.Sizing.Default,
};

export const icon: React.CSSProperties = {
	paddingBottom: TabStyles.Spacing.SmallSpace,
	marginRight: TabStyles.Spacing.DefaultSpace,
};